import { useEffect, useState } from "react";

import styles from "./IQToast.module.css";

/**
 * "+10 IQ" feedback, and a small celebration when a level is crossed.
 *
 * Deliberately unobtrusive: it appears above the tab bar, never blocks a
 * tap, and disappears on its own. The game is the hero (PRD §4.4).
 */
const VISIBLE_MS = 3200;

const IQToast = ({ award, onDismiss }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!award) return undefined;

    setVisible(true);
    const timer = setTimeout(() => {
      setVisible(false);
      onDismiss?.();
    }, VISIBLE_MS);

    return () => clearTimeout(timer);
  }, [award, onDismiss]);

  if (!award || !visible) return null;

  return (
    <div
      className={`${styles.IQToast} ${award.levelledUp ? styles.levelUp : ""}`.trim()}
      role="status"
      aria-live="polite"
    >
      {award.levelledUp ? (
        <>
          <span className={styles.icon} aria-hidden="true">
            <i className={award.newLevel?.icon ?? "fa-solid fa-star"} />
          </span>
          <span className={styles.body}>
            <strong className={styles.title}>New level!</strong>
            <span className={styles.detail}>{award.newLevel?.label}</span>
          </span>
        </>
      ) : (
        <>
          <span className={styles.icon} aria-hidden="true">
            <i className="fa-solid fa-brain" />
          </span>
          <span className={styles.body}>
            <strong className={styles.title}>+{award.xpAwarded} Football IQ</strong>
            <span className={styles.detail}>Nice, that one counts.</span>
          </span>
        </>
      )}
    </div>
  );
};

export default IQToast;
